import { render, staticRenderFns } from "./note-export.vue?vue&type=template&id=2639d104&scoped=true&"
import script from "./note-export.vue?vue&type=script&lang=js&"
export * from "./note-export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2639d104",
  null
  
)

export default component.exports